import { createPortal } from "react-dom";

const Portal = ({children}) => {
    const node = document.createElement('div');
    document.body.appendChild(node);

    return createPortal(children, node);
}

export default Portal;